import { Container } from "inversify";
/**
  It is a wrapper around the "inversify" container
  with global context across the application  
*/
export const ApplicationContext = new Container({defaultScope: "Singleton"});

